// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 97 ? "npm.regenerator-runtime" : chunkId) + "." + {"97":"9f2067d4","414":"7e990b47"}[chunkId] + ".chunk.js";
};